import createSessionContext from 'contexts/Session';
import createBidsOffersContext from 'contexts/BidsOffers';

export const [useSessionContext, SessionProvider] = createSessionContext();

export const [useBidsOffersContext, BidsOffersProvider] =
  createBidsOffersContext();
